import { isTransientFailure } from '../../../domain/services/api/transient.retry';

export const loadDocuments = async ({ requestId, find, onLoaded, setLoading, scheduleReload, logFailure }) => {
    if (!requestId)
        return;

    setLoading(true);

    try {
        const { data } = await find(requestId);
        onLoaded(data || []);
    } catch (error) {
        logFailure(error);
        if (isTransientFailure(error))
            scheduleReload();
    } finally {
        setLoading(false);
    }
};
